import React from 'react';
import { MicroFrontend } from '@xp-utilities/web';

const QuickviewRecommendationsMFE = (({ placementIds, clientId }) => (
  <MicroFrontend
    client="recommendations"
    mfe="CUSTOMER"
    queryString={`clientId=${clientId}&placements=${placementIds}`}
  />
));

export default QuickviewRecommendationsMFE;
